// extracted by mini-css-extract-plugin
export var trailInfoContainer = "styles-module__trailInfoContainer___YWgfR";
export var trailInfo = "styles-module__trailInfo___nqlmU";
export var trailSidebar = "styles-module__trailSidebar___uiNBX";